export default "__VITE_ASSET__862c74c7__"